/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL,
    LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST,
    LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS,
} from './widgetSubscriberMobileConstants';
import {
    IWidgetSubscriberMobileReducer,
    TWidgetSubscriberMobileAction,
} from './widgetSubscriberMobileTypes';

export const widgetSubscriberMobileInitialState: IWidgetSubscriberMobileReducer = {
    data: {
        activeSubs: {
            count: 0,
            names: [],
        },
        blockedSubs: {
            count: 0,
            names: [],
        },
        labels: [],
        noSimCardSubs: {
            count: 0,
            names: [],
        },
        tariffs: [],
    },
    error: '',
    loading: false,

};

const widgetSubscriberMobileReducer: Reducer<IWidgetSubscriberMobileReducer, TWidgetSubscriberMobileAction> =
    (
        state: IWidgetSubscriberMobileReducer = widgetSubscriberMobileInitialState,
        action: TWidgetSubscriberMobileAction,
    ) =>
        produce(state, draft => {
            switch (action.type) {
                case LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST:
                    draft.loading = true;
                    draft.error = widgetSubscriberMobileInitialState.error;
                    draft.data = widgetSubscriberMobileInitialState.data;
                    break;
                case LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS:
                    draft.data = action.payload;
                    draft.loading = false;
                    break;
                case LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL:
                    draft.loading = false;
                    draft.error = action.payload;
                    break;
            }
        });

export default widgetSubscriberMobileReducer;
